export const TITLE_CLASS = "text-3xl font-bold";
export const DESCRIPTION_CLASS = "text-neutral-500 text-xl";
export const QUESTION_CONTAINER_CLASS = "min-h-80";
export const CHOICE_ITEM_CLASS = "inline-flex py-1 px-10 font-normal text-sm text-neutral-500 bg-white border-2 border-neutral-100 rounded-full cursor-pointer peer-checked:border-2 peer-checked:border-bc-blue peer-checked:text-neutral-500 hover:text-neutral-500 hover:bg-neutral-50";
export const TEXT_INPUT_THEME = {
  "addon": "inline-flex items-center rounded-l-md border-0",
  "field": {
    "input": {
      "sizes": {
        "lg": "p-3 sm:text-base font-normal",
        "sm": "px-2 py-0 text-lg font-normal",
      },
      "colors": {
        "gray": "text-neutral-500 bg-neutral-50 border-0 focus:border-0 focus:ring-bc-blue focus:ring-2",
      }
    }
  }
}
export const PARAGRAPH_CLASS = "my-8 font-normal text-xl text-neutral-500";
export const LIST_CLASS = "font-normal text-neutral-500";
